import { useRef, useState } from 'react';
import { Icon } from '@iconify/react';
// mdi:play
import playIcon from '@iconify/icons-mdi/play';
import stopIcon from '@iconify/icons-mdi/stop';
// mdi:gauge-empty
import gaugeEmpty from '@iconify/icons-mdi/gauge-empty';
// mdi:gauge-low
import gaugeLow from '@iconify/icons-mdi/gauge-low';
// mdi:gauge-full
import gaugeFull from '@iconify/icons-mdi/gauge-full';

// material
import { MenuItem, ListItemIcon, ListItemText, Box } from '@mui/material';
import PropTypes from 'prop-types';
import MenuPopover from '../MenuPopover';
import { useTranslation } from '../../common/LocalizationProvider';

// ----------------------------------------------------------------------

FlightReviewReplayVol.propTypes = {
  state: PropTypes.object,
  setState: PropTypes.func,
  setIsOpenSpeedDial: PropTypes.func.isRequired
};

export default function FlightReviewReplayVol({ state, setState, setIsOpenSpeedDial }) {
  const t = useTranslation();

  const ref = useRef(null);

  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <MenuItem
        sx={{ color: 'text.secondary' }}
        ref={ref}
        onClick={() => (state.playVol ? setState({ ...state, playVol: false }) : setIsOpen(true))}
      >
        <Icon icon={state.playVol ? stopIcon : playIcon} width={23} height={23} />
        <ListItemText
          primary={state.playVol ? t('FR_Tooltip_Stop') : t('FR_Tooltip_Play')}
          primaryTypographyProps={{ variant: 'body2' }}
        />
      </MenuItem>

      <MenuPopover
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        sx={{ width: 200 }}
      >
        <Box>
          <MenuItem
            onClick={() => {
              setState({
                ...state,
                speedReplay: 1,
                playVol: true,
                currentPhase: 'all',
                currentPosition: 0
              });
              setIsOpen(false);
              setIsOpenSpeedDial(false);
            }}
            sx={{ color: 'text.secondary' }}
          >
            <ListItemIcon key="speedx1">
              <Icon icon={gaugeEmpty} width={24} height={24} />
            </ListItemIcon>
            <ListItemText
              primary={t('FR_Speed_x1')}
              primaryTypographyProps={{ variant: 'body2' }}
            />
          </MenuItem>
          <MenuItem
            onClick={() => {
              setState({
                ...state,
                speedReplay: 2,
                playVol: true,
                currentPhase: 'all',
                currentPosition: 0
              });
              setIsOpen(false);
              setIsOpenSpeedDial(false);
            }}
            sx={{ color: 'text.secondary' }}
          >
            <ListItemIcon key="speedx2">
              <Icon icon={gaugeLow} width={24} height={24} />
            </ListItemIcon>
            <ListItemText
              primary={t('FR_Speed_x2')}
              primaryTypographyProps={{ variant: 'body2' }}
            />
          </MenuItem>
          <MenuItem
            onClick={() => {
              setState({
                ...state,
                speedReplay: 4,
                playVol: true,
                currentPhase: 'all',
                currentPosition: 0
              });
              setIsOpen(false);
              setIsOpenSpeedDial(false);
            }}
            sx={{ color: 'text.secondary' }}
          >
            <ListItemIcon key="speedx4">
              <Icon icon={gaugeFull} width={24} height={24} />
            </ListItemIcon>
            <ListItemText
              primary={t('FR_Speed_x4')}
              primaryTypographyProps={{ variant: 'body2' }}
            />
          </MenuItem>
        </Box>
      </MenuPopover>
    </>
  );
}
